import { inject } from "@angular/core";
import { CanActivateFn } from "@angular/router";
import { Store } from "@ngrx/store";
import { GlobalState } from "src/app/common/providers/app-state-provider/types/global-state";

export const isTenantGuard: CanActivateFn = () => {
  const store = inject(Store);

  const tenantAccess = store.selectSignal((state: GlobalState) =>{
    return state.appState.accountType === 'TenantRep';
  });

  return tenantAccess();
};
